import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../../config/core.httpclient-utils';

import * as _ from 'lodash-es';

@Component({
    selector: 'adminConfigView',
    template: require('./admin.config.component.html')
})
export class AdminConfigComponent implements OnInit {

    protected configUsage = [];
    protected filter: string = '';
    protected filteredConfig: any = null;
    protected filteredCount: number = 0;

    constructor(
        private httpClient: HttpClient, 
    ) { }
    
    ngOnInit() {
        doGetPromise(
            this.httpClient,
            '/config-usage.json'
        ).then(
            (result: any) => {
                this.configUsage = this.getDisplayValues(result);
            },
            (err) =>  {
                console.log(err);
            }
        ).finally(
            this.filterItems
        );
    }

    includesValue = (search) => {
        return (obj) => Object.values(obj).some( 
            (item: any) => item.includes && item.includes(search)
        );
    };

    filterItems = () => {
        const filterFn = this.includesValue(this.filter);
        this.filteredConfig = this.configUsage.filter(filterFn);
        this.filteredCount = _.size(this.filteredConfig);
    };

    showValue = async (cfg) => {
        cfg.value = null;
        cfg.fetching = true;

        const url = "/api/setting";
        const params = {
            defaultValue: "(no value)",
            settingName: cfg.label
        };

        try {
            const response: any = await doGetPromise(this.httpClient, url, params);
            const setting = _.get(response, "items[0]", { settingValue: params.defaultValue });
            cfg.value = setting.settingValue;
        } catch (err) {
            console.log(err);
            cfg.value = params.defaultValue;
        } finally {
            cfg.fetching = false;
        }
    }

    getDisplayValues(rawConfig) {
        const ret = Object.values(rawConfig)
        .filter( (item: any) => item.status )
        .reduce((acc, item: any) => {
                const key = item.label;
                if (! acc[key]) {
                    acc[key] = item;
                }
                return acc;
            }, {}
        );
        return Object.values(ret);
    }
}